// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GU81","colMin":"styles_colMin__3TN-3"};